module.exports = require("@needle-management/shared-models");